export default (theme) => ({
	root: {
		color: theme.palette.primary.main,
		display: "flex",
		alignItems: "center",
		alignContent: "center",
		textAlign: "center",
		overflow: "scroll"
	},
	wrapper: {
		display: "flex",
		margin: "auto"
	},
	document: {
		// display: "flex"
		// margin: "auto"
	},
	page: {
		// display: "flex"
		// margin: "auto"
	},
	//
	// App: {
	// 	textAlign: "center"
	// },
	// AppHeader: {
	// 	backgroundColor: "#222",
	// 	height: 60,
	// 	padding: 5,
	// 	color: "white"
	// },
	// AppBody: {
	// 	position: "absolute",
	// 	left: 0,
	// 	right: 0,
	// 	top: 60,
	// 	bottom: 0
	// },
	toolbar: {
		position: "fixed",
		left: 0,
		top: 0,
		width: "100%",
		height: "auto",
		// backgroundColor: "rgba(0,0,0,0.5)",
		padding: theme.spacing.unit,
		zIndex: 10,
		display: "flex",
		flexDirection: "row",
		textAlign: "center",
		alignItems: "center",
		alignContent: "center"
	},
	zoomIn: {
		display: "flex",
		backgroundColor: "#fff",
		color: "black",
		margin: 2
	},
	zoomOut: {
		display: "flex",
		backgroundColor: "#fff",
		color: "black",
		margin: 2
	},
	zoomPercent: {
		textAlign: "center",
		fontSize: 16,
		color: "white",
		margin: 2
	},
	viewer: {
		backgroundColor: "#444",
		width: "100%",
		height: "100%",
		position: "relative",
		overflow: "scroll"
	},
	btnBack: {
		display: "inline-flex",
		position: "relative",
		width: 30,
		height: 30,
		minHeight: "auto",
		fontWeight: 900,
		zIndex: 1,
	},
	backActions: {
		position: "absolute",
		color: "white",
		top: 10,
		right: theme.spacing.unit * 2,
		display: "flex",
		"& p": {
			lineHeight: "2rem",
			marginRight: theme.spacing.unit * 2,
		},
		fontWeight: 900,
		zIndex: 2,
	},

});
